import type { Submission } from "@/api/submissions.service";
import {
  CONTACT_LINK_STATE_DESCRIPTIONS,
  CONTACT_LINK_STATE_LABELS,
  type ContactLinkState,
  getContactLinkState,
} from "./contactMatch";
import styles from "./ContactMatch.module.css";

const PILL_CLASS_NAMES: Record<ContactLinkState, string> = {
  linked: styles.pillLinked,
  auto: styles.pillAuto,
  needs_review: styles.pillNeedsReview,
  pending: styles.pillPending,
  no_contact: styles.pillNoContact,
};

type ContactMatchPillProps = {
  entry: Pick<Submission, "contactMatchStatus" | "contactId">;
};

/** The link state of a lawyer entry. Renders nothing for `not_applicable` / unknown. */
export function ContactMatchPill({ entry }: ContactMatchPillProps) {
  const state = getContactLinkState(entry);
  if (!state) return null;
  return (
    <span
      className={`${styles.pill} ${PILL_CLASS_NAMES[state]}`}
      title={CONTACT_LINK_STATE_DESCRIPTIONS[state]}
    >
      {CONTACT_LINK_STATE_LABELS[state]}
    </span>
  );
}
